import { ChangeDetectionStrategy, Component, EventEmitter, Input } from '@angular/core';
import { ImageGroup } from '@spartacus/core';
import { ThumbnailsGroup } from '@spartacus/product/image-zoom/root';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { CarouselModule, MediaModule } from '@spartacus/storefront';
import { ProductImageZoomThumbnailsComponent } from "@spartacus/product/image-zoom/components";

@Component({
  selector: 'gen-product-image-zoom-thumbnails',
  templateUrl: './product-image-zoom-thumbnails.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, CarouselModule, MediaModule],
})
export class GenProductImageZoomThumbnailsComponent extends ProductImageZoomThumbnailsComponent {
 
  @Input() productName: string;
  @Input() override thumbs$: Observable<ThumbnailsGroup[] | any>;
  @Input() override activeThumb: EventEmitter<ImageGroup>;

  override openImage(image: ImageGroup): void {
      super.openImage(image);
      if (typeof image.superZoom?.galleryIndex === 'number') {
        this.productImage.emit({ image, index: image.superZoom.galleryIndex });
      }
  }
}
